module.exports = __webpack_public_path__ + "media/dogs/dogAvatar2-40e175dd.svg";